<template>
<!--hero section start-->
  <v-app>
    <v-container fluid fill-height class="pa-0 gray-bg">
      <v-row no-gutters class="align-items-center justify-content-center fill-height" align="center">
        <v-col class="col-12 col-md-6 col-lg-8  d-none d-md-block fill-height" >
          <!-- Image -->
          <div class="bg-cover background-img fill-height" style="background-image: url(/assets/img/hero-bg-1.jpg);">
            <div class="login-signup-content">
              <div class="col-md-12 col-lg-7">
                  <h2 class="text-white mb-2">Benvenuto in MenuBook!</h2>
                  <p class="lead">L'alta cucina non è una cosa per pavidi: <br />
                    bisogna avere immaginazione, essere temerari, tentare anche l'impossibile.<br />
                    Il vostro unico limite sia il vostro cuore.<br />
                    <br />
                    <i class="font-italic">Ratatouille</i>
                  </p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="col-12 col-md-6 col-lg-4">
          <div class="login-signup-wrap px-4 px-lg-5 my-5" v-if="!submitted">
            <!-- Heading -->
            <h1 class="text-center mb-1">
              Registrazione
            </h1>
            <p class="text-center mb-5">
              Crea il tuo menu in pochi semplici passi.
            </p>

            <!--login form-->
            <v-form ref="form" v-model="valid">
              <label class="pb-1">
                Nome del locale
              </label>
              <v-text-field
                v-model="name"
                placeholder="es: Artizen pub"
                :rules="notEmpty"
                solo
                prepend-inner-icon="person"
                color="#e94e1b"
                @keyup.enter="submit"
              >
              </v-text-field>
              
              <label class="pb-1">
                Email
              </label>
              <v-text-field
                v-model="email"
                placeholder="nome@dominio.com"
                :rules="notEmptyEmail"
                solo
                prepend-inner-icon="email"
                color="#e94e1b"
                @keyup.enter="submit"
              >
              </v-text-field>              
              <v-checkbox
                v-model="terms"
                :rules="notFalse"
                class="no-border"
              >
              <template #label class="d-block">
                  Acconsento ai &nbsp; <a href="/terms.html"> termini e condizioni</a>
                </template>
              </v-checkbox>
                
              
              <!-- Submit -->
              <v-btn large block class="submit-btn" :loading="loading" @click="submit">
                Conferma e passa al menu
              </v-btn>

              <!-- Link -->
              <p class="text-center mt-6">
                  <small class="text-muted text-center">
                    Sei già registrato? <router-link to="/">Accedi</router-link>.
                  </small>
              </p>
              <input hidden  id="g-recaptcha-response" name="g-recaptcha-response" />
            </v-form>
          </div>
          <div v-else>
            <h3 align="center">Registrazione effettuata!</h3>
            <p class="text-center">
              Tra breve riceverai una mail con le tue credenziali.<br>
              Se non vieni reindirizzato a breve alla pagina di login <router-link to="/">clicca qui.</router-link>
            </p>
          </div>
          
        </v-col>
      </v-row> <!-- / .row -->
    </v-container>
      <v-snackbar
        v-model="error"
        timeout="2000"
        color="error"
      >{{snackText}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="error = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
  //eslint-disable-next-line
  import { Auth } from 'aws-amplify'
  import axios from 'axios'

  export default({
    name:"Signup",
    data: function(){
      return{
        error:false,
        snackText: "Si è verificato un errore, riprova più tardi",
        valid:'',
        email:'',
        name:'',
        terms:'',
        loading:false,
        notEmptyEmail: [
          v => !!v || "Inserire l'email",
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Indirizzo non valido.'           
        ],
        notEmpty: [
          v => !!v || "Inserire il nome del locale"
        ],
        notFalse: [
          v => v || "Campo obbligatorio"
        ],
        submitted:false
      }
    },
    methods:{
   
      submit:function(){
        if(this.$refs.form.validate()){
          this.loading=true
          var params ={
            "title":this.name,
            "email":this.email,
            "account":this.$route.params.account,
            "terms-agree":this.terms,
            "captcha":document.getElementById("g-recaptcha-response").value,
            "default-lang":'it',
          }
          var cookie = this.$cookies.get('tag')
          console.log(cookie)
          
          if(cookie)
            params['affiliation_code'] = cookie

          axios.post(localStorage.Endpoint+"/signup",params)
           //eslint-disable-next-line
          .then(response =>{
            this.submitted = true
            setTimeout(()=>{this.$router.push("/")},5000)
            //send confirmation code
          })
          //eslint-disable-next-line
          .catch(error => {
            if(error.response)
              this.snackText = error.response.data.message
            if(error.request)
              this.snackText = "Non è stato possibile completare la procedura a causa di un errore di rete. Riprova più tardi"
            this.error=true
            this.loading=false
          })
        }
      }
    }
  })
</script>
<style>
.background-img{
    position: relative;
    width: 100%;
    display: block;
    background-size: cover;
    background-position: center;
}
.background-img:before{
    position: absolute;
    content: '';
    background-color: rgba(233, 78, 27, 0.62);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.gray-bg{
  background-color:#f4f7fa
}

/*login css*/
.login-signup-content{
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#fff;
    position: absolute;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.75
}

.login-signup-content h2{
  font-size:2.5em;
  line-height: 1.21;
}
.login-signup-content .lead{
  font-size:1.25em
}
label{
  font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 88%;
}

.v-input:not(.no-border) .v-input__slot{
  border-color: #e94e1b !important;
  border-style: solid;
  border-width: 0 0 0 2px;
}

.v-input.no-border .v-input__slot{
  border-width:0 0 0 0;
}
.v-input.no-border .v-label{
  display: block;
}

.submit-btn{
  background-color: #e94e1b !important;
  color: #fff !important;
}

</style>